/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { CreditScoreRange, AnnualIncome, MostRecentEviction } from '.zenstack/models';
import { CreditScoreRangeSchema } from '../enums/CreditScoreRange.schema';
import { AnnualIncomeSchema } from '../enums/AnnualIncome.schema';
import { MostRecentEvictionSchema } from '../enums/MostRecentEviction.schema';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string().optional(),
    biography: z.any().nullish(),
    creditScoreRange: CreditScoreRangeSchema,
    annualIncome: AnnualIncomeSchema,
    mostRecentEviction: MostRecentEvictionSchema,
    mostRecentEvictionProvided: z.coerce.date().default(() => new Date()).nullish(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string().optional(),
    biography: z.any().nullish(),
    creditScoreRange: CreditScoreRangeSchema,
    annualIncome: AnnualIncomeSchema,
    mostRecentEviction: MostRecentEvictionSchema,
    mostRecentEvictionProvided: z.coerce.date().nullish(),
}
).strict();
const relationSchema = z.object({
    user: z.record(z.string(), z.unknown()),
    bids: z.array(z.unknown()).optional(),
}
);
const fkSchema = z.object({
    id: z.string().optional(),
}
);

/**
 * `PropertySeeker` schema excluding foreign keys and relations.
 */
export const PropertySeekerScalarSchema = baseSchema;


/**
 * `PropertySeeker` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const PropertySeekerSchema = PropertySeekerScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const PropertySeekerPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const PropertySeekerPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string().optional(),
    biography: z.any().nullish(),
    creditScoreRange: CreditScoreRangeSchema,
    annualIncome: AnnualIncomeSchema,
    mostRecentEviction: MostRecentEvictionSchema,
    mostRecentEvictionProvided: z.coerce.date().nullish()
}).partial().passthrough();


/**
 * `PropertySeeker` schema for create operations excluding foreign keys and relations.
 */
export const PropertySeekerCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, creditScoreRange: true, annualIncome: true, mostRecentEviction: true, mostRecentEvictionProvided: true
});


/**
 * `PropertySeeker` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const PropertySeekerCreateSchema = PropertySeekerCreateScalarSchema.merge(fkSchema);


/**
 * `PropertySeeker` schema for update operations excluding foreign keys and relations.
 */
export const PropertySeekerUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `PropertySeeker` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const PropertySeekerUpdateSchema = PropertySeekerUpdateScalarSchema.merge(fkSchema.partial());

